var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrap",class:_vm.item.css_class,on:{"click":_vm.handleLink}})}
var staticRenderFns = []

export { render, staticRenderFns }